/* tslint:disable */
import {
  UserAccount,
  Lesson
} from '../index';

declare var Object: any;
export interface LessonProgressInterface {
  "userAccountId": number;
  "lessonId": number;
  "completed"?: boolean;
  "name"?: string;
  "description"?: string;
  "data"?: any;
  "createdAt": Date;
  "createdBy"?: number;
  "updatedAt": Date;
  "updatedBy"?: number;
  "id"?: number;
  user?: UserAccount;
  lesson?: Lesson;
}

export class LessonProgress implements LessonProgressInterface {
  "userAccountId": number;
  "lessonId": number;
  "completed": boolean;
  "name": string;
  "description": string;
  "data": any;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  user: UserAccount;
  lesson: Lesson;
  constructor(data?: LessonProgressInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LessonProgress`.
   */
  public static getModelName() {
    return "LessonProgress";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LessonProgress for dynamic purposes.
  **/
  public static factory(data: LessonProgressInterface): LessonProgress{
    return new LessonProgress(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LessonProgress',
      plural: 'LessonProgresses',
      path: 'LessonProgresses',
      idName: 'id',
      properties: {
        "userAccountId": {
          name: 'userAccountId',
          type: 'number'
        },
        "lessonId": {
          name: 'lessonId',
          type: 'number'
        },
        "completed": {
          name: 'completed',
          type: 'boolean',
          default: false
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "data": {
          name: 'data',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        user: {
          name: 'user',
          type: 'UserAccount',
          model: 'UserAccount',
          relationType: 'belongsTo',
                  keyFrom: 'userAccountId',
          keyTo: 'id'
        },
        lesson: {
          name: 'lesson',
          type: 'Lesson',
          model: 'Lesson',
          relationType: 'belongsTo',
                  keyFrom: 'lessonId',
          keyTo: 'id'
        },
      }
    }
  }
}
